import "./Main.css";

export const Header = () => {
	return (
		<header className='header'>
			<img
				src='/images/logo-transparent-svg.svg'
				alt='logo'
			/>
		</header>
	);
};
export const Footer = () => {
	return (
		<footer className='footer'>
			<p>© 2024</p>
			<p>Created by Teejay </p>
		</footer>
	);
};

export const Guide = () => {
	return (
		<div className='guide'>
			{/* <h3>Click on the screens to view more</h3> */}
			<h3>Press 'esc' to exit</h3>
		</div>
	);
};

const Layout = (props) => {
	return (
		<>
			<Header />
			<main className='main_content'>{props.children}</main>
			<Footer />
		</>
	);
};

export default Layout;
